import React from 'react';
import { Container } from '@fiverr-private/layout_components';
import { Text } from '@fiverr-private/typography';
import {
  ResponsiveDisplayType,
  ResponsiveHeightType,
  ResponsiveTextAlignType,
  ResponsiveWidthType,
  SelectorBackgroundColorsType,
} from '@fiverr-private/theme/src/components/Box/types';
import { theme } from '@fiverr-private/theme';
import SellerBadge from '../SellerBadge';
import LazyImageWithSrcset from '../LazyImageWithSrcset';

import { brandPageTheme } from '../../shared/constants';
import { sellerCell } from './styles.ve.css';

interface SellerCellProps {
  name: string;
  domain?: string;
  isFade?: boolean;
  className?: string;
  width?: ResponsiveWidthType | undefined;
  height?: ResponsiveHeightType | undefined;
  backgroundColor?: SelectorBackgroundColorsType;
  background?: string;
  textAlign?: ResponsiveTextAlignType;
  'data-speed'?: string;
  dataLag?: string;
  display?: ResponsiveDisplayType;
  style?: React.CSSProperties;
  alt?: string;
  src?: string;
  imgWidth?: Partial<
    Record<'default' | keyof typeof theme.breakpoints | keyof typeof brandPageTheme.breakpoints, number>
  >;
}

const SellerCell: React.FC<SellerCellProps> = ({
  name,
  domain = '',
  isFade = true,
  className,
  alt,
  src,
  imgWidth,
  ...restProps
}: SellerCellProps) => (
  <Container
    data-scroll-fade-out={isFade}
    position="relative"
    zIndex={isFade ? '1' : '2'}
    overflow="hidden"
    borderRadius="xl"
    className={`${sellerCell} ${className}`}
    {...restProps}
  >
    <Text visibility="hidden">{name}</Text>
    {alt && src && imgWidth && <LazyImageWithSrcset src={src} alt={alt} imgWidth={imgWidth} />}
    {domain && <SellerBadge name={name} domain={domain} />}
  </Container>
);

export default SellerCell;
